import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component } from 'react';
import Moment from "moment";
import { apiFetch, API, getMarket } from "../../services/api";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Modal de création / édition d'un évènement de captation (salon). Le back-end
// génère automatiquement le slug, le QR code et le segment Mailchimp.
export default class AddEventCaptureModal extends Component {
    constructor(props) {
        super(props);
        const event = props.selectedEvent || {};
        this.state = {
            id: event.id || "",
            name: event.name || "",
            date: event.date ? Moment(event.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
            cost: event.cost || 0,
            active: event.active !== undefined ? event.active : true,
            qrCode: event.QRCode || event.qrCode || "",
            slug: event.slug || "",
            loading: false,
            error: null,
        };
    }

    handleSubmit = () => {
        if (!this.state.name) {
            this.setState({ error: "Le nom est obligatoire" });
            return;
        }
        this.setState({ loading: true, error: null });

        const body = {
            id: this.state.id,
            name: this.state.name,
            slug: this.state.slug,
            date: Moment(this.state.date).toISOString(),
            cost: Number(this.state.cost) || 0,
            active: this.state.active,
            QRCode: this.state.qrCode,
            language: getMarket(),
        };

        apiFetch(API.back + '/event-capture', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        })
            .then(async () => {
                await sleep(1500);
                window.location.reload(false);
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, error: "Erreur lors de l'enregistrement" });
            });
    }

    render() {
        return (
            <Modal show={this.props.isOpen} onHide={this.props.closeModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.id ? "Modifier" : "Ajouter"} un évènement de captation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nom de l'évènement</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ex : Ultra Marin"
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={this.state.date}
                                onChange={(e) => this.setState({ date: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Coût de l'évènement (€)</Form.Label>
                            <Form.Control
                                type="number"
                                min={0}
                                step="0.01"
                                value={this.state.cost}
                                onChange={(e) => this.setState({ cost: e.target.value })}
                            />
                            <Form.Text className="text-muted">Sert au calcul du ROI (revenus générés vs coût).</Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="switch"
                                label="Actif"
                                checked={this.state.active}
                                onChange={(e) => this.setState({ active: e.target.checked })}
                            />
                        </Form.Group>
                        {this.state.qrCode ? (
                            <Form.Group className="mb-3">
                                <Form.Label>QR code (généré automatiquement)</Form.Label>
                                <div>
                                    <img src={this.state.qrCode} alt="QR code" style={{ width: 160, height: 160 }} />
                                </div>
                            </Form.Group>
                        ) : null}
                        {this.state.error ? <p style={{ color: "#c0392b" }}>{this.state.error}</p> : null}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.closeModal}>Annuler</Button>
                    <Button variant="primary" onClick={this.handleSubmit} disabled={this.state.loading}>
                        {this.state.loading ? "Enregistrement…" : "Valider"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
